var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',_vm._g({class:["mpx-root-view","host-_09b7fdbf"]},_vm.$listeners),[_c('cube-float-ball',{on:{"_click":_vm.handleClick}},[_c('mpx-image',{class:["float-ball-demo"],attrs:{"src":"https://dpubstatic.udache.com/static/dpubimg/TRSp1qfRVjgrDF9Lr-OyN_service-assist.png"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }